import notify from "devextreme/ui/notify";
import {custom} from 'devextreme/ui/dialog';
import {DialogButton, DialogButtonAnswer} from "../constants/Constants";

function getFilterMap(tempGrid) {

    let gridColumns = tempGrid.props.children.filter(function (x) {
        if ((x.type.name === "Column" || x.type.OptionName ==="columns")  && x.props.dataField !== null)
            return x
    })

    let array = [];
    gridColumns.map(column => {
        let filter = {};
        filter.dataField = column.props.dataField;
        filter.mapField = column.props.dataField;
        filter.dataType = column.props.dataType;
        filter.mappingType =column.props.mappingType;
        if(column.props.mappingField != null){
            filter.mapField = column.props.mappingField;
        }
        filter.mappingField =filter.mapField;
        array.push(filter);
    }); 
    return array;
}

function sortNormalize(sorts, filterMap) {
    if (sorts && isNotEmpty(sorts)) {
        sorts.map(sort => {
            let column = filterMap.filter(x => {
                if (x.dataField == sort.selector)
                    return x;
            });

            if (column.length > 0) {
                sort.selector = column[0].mapField;
            }  
        });
    }
    return sorts;
}


function getGridLoadOptionsParams(loadOptions, filterMap,addFiltersArray) {

    let params = '?';

    ['skip', 'take', 'requireTotalCount', 'requireGroupCount',
        'totalSummary', 'group', 'groupSummary'].forEach(function (i) {
            if (i in loadOptions && isNotEmpty(loadOptions[i])) {
                params += `${i}=${JSON.stringify(loadOptions[i])}&`;
            }
        });

    if (loadOptions['sort'] && isNotEmpty(loadOptions['sort'])) {
        let sortArray = sortNormalize(loadOptions['sort'], filterMap);
        params += `sort=${JSON.stringify(sortArray)}&`;
    }

    let filterArr = [];
    if (loadOptions['filter'] && isNotEmpty(loadOptions['filter'])) {
        filterArr = filterNormalizeYeni(loadOptions['filter'], filterMap);
    }
    if (addFiltersArray && addFiltersArray.length > 0) {
        addFiltersArray.map(addFilter => {
            filterArr.push(addFilter)  ;
        });
    }
    
    if (filterArr.length > 0) {
        params += "filter=" + JSON.stringify(filterArr);
    } else {
        params = params.slice(0, -1);
    } 
    params = encodeURI(params);
    return params;
}


function filterNormalizeYeni(filter, filterMap) {
    if (filter && isNotEmpty(filter)) {
        let filterArr = [];
        if (Array.isArray(filter[0])) {
            filter.map(x => {
                if (Array.isArray(x)) {
                    let flt = toFilterYeni(x, filterMap);
                    if (flt) {
                        filterArr.push(flt);
                    }
                } else {
                    //and or vb i
                }
            })
        } else {
            let flt = toFilterYeni(filter, filterMap);
            if (flt) {
                filterArr.push(flt);
            }
        }
        return filterArr;
    }
    return null;
}

function toFilterYeni(filterObjArr, filterMap) {
    let column = filterMap.filter(x => {
        if (x.dataField == filterObjArr[0] || x.mappingField == filterObjArr[0])
            return x;
    });
    if (column.length>0) {
        column =  column[0];
        //değerlendirilecek
        // if(filterObjArr[1] == "contains" && filterObjArr[2] != null 
        // && filterObjArr[2].length >0 && !filterObjArr[2].startsWith('%')
        // && (column.mappingType || column.dataType) =="string"){
        //     filterObjArr[2] = "%" + filterObjArr[2] ;
        // }
        
        if(filterObjArr[2] != null && (column.mappingType || column.dataType) =="date" && filterObjArr[2] instanceof Date){
            filterObjArr[2] =parseApiDate( filterObjArr[2]);
        }
       
        return {
            property: column.mappingField || filterObjArr[0],
            operator: normalizeOperatorYeni(filterObjArr[1]),
            value: filterObjArr[2],
            type: column.mappingType || column.dataType
        };
    } else {
        return null;
    }
}

function normalizeOperatorYeni(operator) {
    console.log(operator);
    switch(operator) {
        case "<>":
            return "!="
            break;
        case "contains":
            return "LIKE"
            break;
        case "notcontains":
            return "!="
            break;
        case "startswith":
            return "LIKE"
            break;
        case "endswith":
            return "LIKE"
            break;
        default:
            return operator
    }


}
























function filterNormalize(filter, gridColumns) {
    if (filter && isNotEmpty(filter)) {
        let filterArr = [];
        if (Array.isArray(filter[0])) {
            filter.map(x => {
                if (Array.isArray(x)) {
                    let flt = toFilter(x, gridColumns);
                    if (flt) {
                        filterArr.push(flt);
                    }
                } else {
                    //and or vb i
                }
            })
        } else {
            let flt = toFilter(filter, gridColumns);
            if (flt) {
                filterArr.push(flt);
            }
        }
        return filterArr;
    }
    return null;
}

function toFilter(filterObjArr, gridColumn) {
    let column = gridColumn.filter(x => {
        if (x.props.dataField == filterObjArr[0] || x.props.mappingField == filterObjArr[0])
            return x;
    });
    if (column.length>0) {

        column =  column[0];
        return {
            property: column.props.mappingField || filterObjArr[0],
            operator: normalizeOperator(filterObjArr[1]),
            value: filterObjArr[2],
            type: column.props.mappingType || column.props.dataType
        };
    } else {
        return null;
    }
}

function normalizeOperator(operator) {
    console.log(operator);
    switch(operator) {
        case "<>":
            return "!="
            break;
        case "contains":
            return "LIKE"
            break;
        case "notcontains":
            return "!="
            break;
        case "startswith":
            return "LIKE"
            break;
        case "endswith":
            return "LIKE"
            break;
        default:
            return operator
    }


}

function isNotEmpty(value) {
    return value !== undefined && value !== null && value !== '';
}


const showToast = (message, type, displayTime = 500) => {
    notify({message: message, position: "top right"}, type, displayTime);
}

function getDialogButtons(buttons) {
    switch (buttons) {
        case DialogButton.OK:
            return [
                {
                    tag: DialogButtonAnswer.OK,
                    text: "Tamam",
                    onClick: (e) => {
                        return {buttonTag: e.component.option("tag")}
                    }
                }
            ];
        case DialogButton.OK_CANCEL:
            return [
                {
                    tag: DialogButtonAnswer.OK,
                    text: "Tamam",
                    onClick: (e) => {
                        return {buttonTag: e.component.option("tag")}
                    }
                }, {
                    tag: DialogButtonAnswer.CANCEL,
                    text: "İptal",
                    onClick: (e) => {
                        return {buttonTag: e.component.option("tag")}
                    }
                }
            ];
        case DialogButton.YES_NO:
            return [
                {
                    tag: DialogButtonAnswer.YES,
                    text: "Evet",
                    onClick: (e) => {
                        return {buttonTag: e.component.option("tag")}
                    }
                }, {
                    tag: DialogButtonAnswer.NO,
                    text: "Hayır",
                    onClick: (e) => {
                        return {buttonTag: e.component.option("tag")}
                    }
                }
            ];
        default :
            return [
                {
                    tag: DialogButtonAnswer.YES,
                    text: "Evet",
                    onClick: (e) => {
                        return {buttonTag: e.component.option("tag")}
                    }
                }, {
                    tag: DialogButtonAnswer.NO,
                    text: "Hayır",
                    onClick: (e) => {
                        return {buttonTag: e.component.option("tag")}
                    }
                }
            ];
    }
}

function parseDate(dateStr){

    if (dateStr != null ) {
        if(dateStr instanceof Date){
            return dateStr;
        }
        let gun  =dateStr.substring(0,2);
        let ay  =parseInt(dateStr.substring(3,5)) -1;
        let yil  =dateStr.substring(6,10);
        let saat  =dateStr.substring(11,13);
        let dakika  =dateStr.substring(14,16);
        let sanye  =dateStr.substring(17,19);

        return new Date(yil,ay,gun,saat,dakika,sanye);
    }
    return null;
}

function parseApiDate(date) {
    if (date != undefined && date != null && date instanceof Date) {
        return date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' });
    }
    return date;
}

function hasRole(roleName) {
    let roles = JSON.parse(localStorage.getItem("roles"));  
    if(roles && roles.length >0){
        return roles.indexOf(roleName)>-1;
    }
    return false;
}

function hasRoles(roles) {
    let rols = JSON.parse(localStorage.getItem("roles"));  
    if(rols && rols.length >0){
        let count = 0;
        roles.map(d => {
            if(rols.indexOf(d)>-1){
                count++;
            } 
        }); 
        return count >0;
        
    }
    return false;
}

function hasUser(userName) {
    let loginUser = localStorage.getItem("username");  
    if(loginUser && loginUser == userName){
        return true;
    }
    return false;
}



const showDialog = async (data) => new Promise((resolve) => {
    let myDialog = custom({
        title: data.title,
        messageHtml: "<b>" + data.message + "</b>",
        buttons: getDialogButtons(data.buttons)
    });
    myDialog.show().then((dialogResult) => {
        resolve(dialogResult.buttonTag);
    });

    // //custom(title,message,buttons,true,true);
    // setTimeout(function (){
    //
    //    resolve(message);
    //
    // }, 5000);

})


export {showToast,hasRole,hasUser,hasRoles, showDialog, filterNormalize, isNotEmpty,parseDate,sortNormalize,getFilterMap,getGridLoadOptionsParams,filterNormalizeYeni,toFilterYeni,normalizeOperatorYeni,parseApiDate};
